// Global light/dark theme handling. Class strategy on <html>.
export function getInitialTheme() {
  try {
    const saved = localStorage.getItem("ns_theme");
    if (saved === "dark" || saved === "light") return saved;
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
  } catch (e) { /* ignore */ }
  return "light";
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  try { localStorage.setItem("ns_theme", theme); } catch (e) { /* ignore */ }
}

// Apply immediately on import to avoid a flash of the wrong theme.
applyTheme(getInitialTheme());
